import React from "react";
import { ImLinkedin2 } from "react-icons/im";
import { RiGithubLine } from "react-icons/ri";
const Footer = () => {
  return (
    <div className="mt-32 mb-10">
      <div>
        <p className="text-accent hover:text-primary cursor-pointer text-center font-mono mb-2">
          Design by Ahsan Kabir
        </p>
        <span className="flex cursor-pointer items-center justify-center">
          <ImLinkedin2  className="text-accent hover:text-primary"/>
          <RiGithubLine  className="ml-2 text-accent hover:text-primary"/>
        </span>
      </div>
    </div>
  );
};

export default Footer;
